import React from 'react';
import { ReactComponent as IconComponent } from '@THC/assets/svgs/graph.svg';
import { Icon } from '../Icon/Icon';
export const GraphIcon = (props) => (<Icon {...props}>
		<IconComponent />
	</Icon>);
